
	     
const columnList: Array<any> = [
    {
        prop: "position_name",
        label: "名称",
        width: 150,
    },
    {
        prop: "sort",
        label: "排序",
        width: 100,
    }
 
];
import {Request} from '@/api/request';

import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
} from "vue";
import { getPurchaseTable, getSupplierList } from "@/api/http";
import { column } from "@/assets/types/common";

export default defineComponent({
    name: "personnelPosition",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["职位管理"]);
        let pageSize = ref(10),
            currentPage = ref(1),
            tableData = ref([] as Array<any>),
            loading = ref(true),
            headClass = inject("headClass"),
            screenParameter: any = {
                page: currentPage.value,
                limit: pageSize.value,
                search: "",
                position_id: ""
            },
            dialog_show = ref(false),
			dialog_title = ref(''),
			form = ref({
				position_id: 0,
				position_name: '',
				sort: ''
			}),
			formRef = ref(null),
			form_isload = ref(false),
			form_rules = {
				position_name: [
					{required: true, message: '请输入职位名称', trigger: 'blur'},
				]
			},
            getTableData = (): void => {
                loading.value = true;
				Request.axiosInstance({
					url: 'adminapi/Position/list',
					data: screenParameter
				}).then((res: any) => {
					tableData.value = res?.content?.list || [];
					loading.value = false;
				})
            },
			_uprowStatus = (id: number, status: number): void => {
				loading.value = true
				Request.axiosInstance({
					url: 'adminapi/Position/upState',
					data: {position_id: id, status: (status == 0 ? 1 : 0)}
				}).then((res: any) => {
					getTableData()
				})
			},
			_editinfo = (id: number, name: string, sort: string) => {
				form.value = {
					position_id: id,
					position_name: name,
					sort: sort
				}
				dialog_title.value = '修改职位'
				dialog_show.value = true
				form_isload.value = false
			},
			_addinfo = () => {
				form.value = {
					position_id: 0,
					position_name: '',
					sort: ''
				}
				dialog_title.value = '增加职位'
				dialog_show.value = true
				form_isload.value = false
			},
			_formSubmit = () => {
				form_isload.value = true
				
				
				Request.axiosInstance({
					url: dialog_title.value == '增加职位' ? 'adminapi/Position/create' : 'adminapi/Position/edit',
					data:  form.value
				}).then(() => {
					dialog_show.value = false
					getTableData()
				})
			}
          
 
        onMounted(() => {
            getTableData();
        });

        return {
            columnList,
            tableData,
            loading,
            headClass,
            screenParameter,
			_uprowStatus,
			dialog_show,
			dialog_title,
			form,
			formRef,
			form_rules,
			form_isload,
			_editinfo,
			_formSubmit,
			_addinfo
        };
    },
});
